import { useDispatch } from '@witmetrics/data-store';
import { API } from '@/api';
import { showSuccessToaster } from '@/utils/toasters';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { TrashIcon } from '@/icons';
import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type DeleteFormSubmissionDialogProps = {
  submissionId: number;
  onClose: () => void;
};

export default function DeleteFormSubmissionDialog({
  submissionId,
  onClose,
}: DeleteFormSubmissionDialogProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const [isDeleting, toggleDeleting] = useToggle();

  const handleDelete = async () => {
    try {
      toggleDeleting(true);
      await API.Forms.removeFormSubmission(submissionId);
      dispatch.deleteSubmission({ submissionId });
      showSuccessToaster('Form submission deleted');
      toggleDeleting(false);
      onClose();
    } catch (err) {
      toggleDeleting(false);
      onApiError(err, 'Error deleting form submission');
    }
  };

  return (
    <DefaultDialog
      disabled={isDeleting}
      pending={isDeleting}
      variant="confirm"
      icon={<TrashIcon size="1.375rem" />}
      confirmLabel="Delete"
      pendingLabel="Deleting"
      title="Delete form submission"
      message="Are you sure you want to delete this form submission? This action cannot be undone."
      onCancel={onClose}
      onConfirm={handleDelete}
      onClose={onClose}
    />
  );
}
